// extracted by mini-css-extract-plugin
module.exports = {"card-edit":"CardEdit_card-edit__1-3oz","card-edit-form":"CardEdit_card-edit-form__1Bkdd","button":"CardEdit_button__2QgAy"};